import * as React from 'react'

export type DropdownContextProps = {
  open: boolean
  toggle: () => void
  mobile: boolean
}

export const DropdownContext = React.createContext({} as DropdownContextProps)
